var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayicon = function SvgPlayicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2A10 10 0 1 1 2 12Zm8.17 4.28L16 12.64a.76.76 0 0 0 0-1.28l-5.85-3.64A.75.75 0 0 0 9 8.35v7.3a.75.75 0 0 0 1.17.63Z",
    clipRule: "evenodd"
  })));
};
export default SvgPlayicon;